import styled from 'styled-components'

export const Card = styled.article`
  width: 18rem;
  height: 14rem;

  background: #ffffff;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  border-radius: 25px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  position: relative;
  text-align: center;

  .hide {
    opacity: 0;
  }

  &:hover {
    .hide {
      opacity: 1;
    }
    .wait {
      opacity: 0;
      cursor: default;
    }
  }
`
export const ListCard = styled.article<{ noBackground?: boolean }>`
  min-width: 100%;
  //height: 3rem;

  background: ${props => (props.noBackground ? 'transparent' : '#ffffff')};
  box-shadow: ${props => (props.noBackground ? '' : '4px 4px 18px -5px rgba(218, 221, 232, 0.8)')};
  border-radius: 15px;
  align-items: center;

  padding: 1.5rem 1rem;

  display: grid;
  grid-template-columns: 25% 15% 30% 25% 5%;

  position: relative;
  text-align: left;

  .hide {
    opacity: 0;
  }

  &:hover {
    .hide {
      opacity: 1;
    }
    .wait {
      opacity: 0;
      cursor: default;
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`
export const Button = styled.button<{ listView?: boolean }>`
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  right: 1rem;

  top: ${props => (props.listView ? '1.64rem' : '1rem')};
`
export const Container = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`
export const CardMobile = styled(Card)`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    width: 100%;
  }
`
